import type { LocaleKey } from "@/i18n";
import { normalizeLocaleKey } from "@/i18n";

// Board type translations for all supported languages
const boardTypeTranslations: Record<LocaleKey, Record<string, string>> = {
  es: {
    // Portuguese inputs
    "sem café da manhã": "Sin desayuno",
    "sem cafe da manha": "Sin desayuno",
    "sem café da manha": "Sin desayuno",
    "sem cafe da manhã": "Sin desayuno",
    "café da manhã": "Desayuno incluido",
    "café da manha": "Desayuno incluido",
    "cafe da manha": "Desayuno incluido",
    "cafe da manhã": "Desayuno incluido",
    "somente café da manhã": "Solo desayuno",
    "meia pensão": "Media pensión",
    "meia pensao": "Media pensión",
    "pensão completa": "Pensión completa",
    "pensao completa": "Pensión completa",
    "tudo incluído": "Todo incluido",
    "tudo incluido": "Todo incluido",
    "tudo incluso": "Todo incluido",
    "all-inclusive": "Todo incluido",
    "sem refeições": "Sin comidas",
    "sem refeicoes": "Sin comidas",
    "apenas acomodação": "Solo alojamiento",
    "apenas acomodacao": "Solo alojamiento",

    // English inputs
    "no breakfast": "Sin desayuno",
    "without breakfast": "Sin desayuno",
    "bed and breakfast": "Desayuno incluido",
    "breakfast": "Desayuno incluido",
    "breakfast included": "Desayuno incluido",
    "half board": "Media pensión",
    "full board": "Pensión completa",
    "all inclusive": "Todo incluido",
    "room only": "Solo alojamiento",
    "no meals": "Sin comidas",

    // Spanish inputs
    "sin desayuno": "Sin desayuno",
    "desayuno incluido": "Desayuno incluido",
    "solo desayuno": "Solo desayuno",
    "media pensión": "Media pensión",
    "media pension": "Media pensión",
    "pensión completa": "Pensión completa",
    "pension completa": "Pensión completa",
    "todo incluido": "Todo incluido",
    "sin comidas": "Sin comidas",
    "solo alojamiento": "Solo alojamiento",
  },
  en: {
    // Portuguese inputs
    "sem café da manhã": "No breakfast",
    "sem cafe da manha": "No breakfast",
    "sem café da manha": "No breakfast",
    "sem cafe da manhã": "No breakfast",
    "café da manhã": "Breakfast included",
    "café da manha": "Breakfast included",
    "cafe da manha": "Breakfast included",
    "cafe da manhã": "Breakfast included",
    "somente café da manhã": "Breakfast only",
    "meia pensão": "Half board",
    "meia pensao": "Half board",
    "pensão completa": "Full board",
    "pensao completa": "Full board",
    "tudo incluído": "All inclusive",
    "tudo incluido": "All inclusive",
    "tudo incluso": "All inclusive",
    "all-inclusive": "All inclusive",
    "sem refeições": "No meals",
    "sem refeicoes": "No meals",
    "apenas acomodação": "Room only",
    "apenas acomodacao": "Room only",

    // English inputs
    "no breakfast": "No breakfast",
    "without breakfast": "No breakfast",
    "bed and breakfast": "Breakfast included",
    "breakfast": "Breakfast included",
    "breakfast included": "Breakfast included",
    "half board": "Half board",
    "full board": "Full board",
    "all inclusive": "All inclusive",
    "room only": "Room only",
    "no meals": "No meals",

    // Spanish inputs
    "sin desayuno": "No breakfast",
    "desayuno incluido": "Breakfast included",
    "solo desayuno": "Breakfast only",
    "media pensión": "Half board",
    "media pension": "Half board",
    "pensión completa": "Full board",
    "pension completa": "Full board",
    "todo incluido": "All inclusive",
    "sin comidas": "No meals",
    "solo alojamiento": "Room only",
  },
  "pt-BR": {
    // Portuguese inputs
    "sem café da manhã": "Sem café da manhã",
    "sem cafe da manha": "Sem café da manhã",
    "sem café da manha": "Sem café da manhã",
    "sem cafe da manhã": "Sem café da manhã",
    "café da manhã": "Café da manhã incluído",
    "café da manha": "Café da manhã incluído",
    "cafe da manha": "Café da manhã incluído",
    "cafe da manhã": "Café da manhã incluído",
    "somente café da manhã": "Somente café da manhã",
    "meia pensão": "Meia pensão",
    "meia pensao": "Meia pensão",
    "pensão completa": "Pensão completa",
    "pensao completa": "Pensão completa",
    "tudo incluído": "Tudo incluído",
    "tudo incluido": "Tudo incluído",
    "tudo incluso": "Tudo incluído",
    "all-inclusive": "Tudo incluído",
    "sem refeições": "Sem refeições",
    "sem refeicoes": "Sem refeições",
    "apenas acomodação": "Apenas acomodação",
    "apenas acomodacao": "Apenas acomodação",

    // English inputs
    "no breakfast": "Sem café da manhã",
    "without breakfast": "Sem café da manhã",
    "bed and breakfast": "Café da manhã incluído",
    "breakfast": "Café da manhã incluído",
    "breakfast included": "Café da manhã incluído",
    "half board": "Meia pensão",
    "full board": "Pensão completa",
    "all inclusive": "Tudo incluído",
    "room only": "Apenas acomodação",
    "no meals": "Sem refeições",

    // Spanish inputs
    "sin desayuno": "Sem café da manhã",
    "desayuno incluido": "Café da manhã incluído",
    "solo desayuno": "Somente café da manhã",
    "media pensión": "Meia pensão",
    "media pension": "Meia pensão",
    "pensión completa": "Pensão completa",
    "pension completa": "Pensão completa",
    "todo incluido": "Tudo incluído",
    "sin comidas": "Sem refeições",
    "solo alojamiento": "Apenas acomodação",
  },
  "en-EU": {
    // Portuguese inputs
    "sem café da manhã": "No breakfast",
    "sem cafe da manha": "No breakfast",
    "sem café da manha": "No breakfast",
    "sem cafe da manhã": "No breakfast",
    "café da manhã": "Breakfast included",
    "café da manha": "Breakfast included",
    "cafe da manha": "Breakfast included",
    "cafe da manhã": "Breakfast included",
    "somente café da manhã": "Breakfast only",
    "meia pensão": "Half board",
    "meia pensao": "Half board",
    "pensão completa": "Full board",
    "pensao completa": "Full board",
    "tudo incluído": "All inclusive",
    "tudo incluido": "All inclusive",
    "tudo incluso": "All inclusive",
    "all-inclusive": "All inclusive",
    "sem refeições": "No meals",
    "sem refeicoes": "No meals",
    "apenas acomodação": "Room only",
    "apenas acomodacao": "Room only",

    // English inputs
    "no breakfast": "No breakfast",
    "without breakfast": "No breakfast",
    "bed and breakfast": "Breakfast included",
    "breakfast": "Breakfast included",
    "breakfast included": "Breakfast included",
    "half board": "Half board",
    "full board": "Full board",
    "all inclusive": "All inclusive",
    "room only": "Room only",
    "no meals": "No meals",

    // Spanish inputs
    "sin desayuno": "No breakfast",
    "desayuno incluido": "Breakfast included",
    "solo desayuno": "Breakfast only",
    "media pensión": "Half board",
    "media pension": "Half board",
    "pensión completa": "Full board",
    "pension completa": "Full board",
    "todo incluido": "All inclusive",
    "sin comidas": "No meals",
    "solo alojamiento": "Room only",
  },
};

const defaultTranslations: Record<LocaleKey, string> = {
  es: "No especificado",
  en: "Not specified",
  "pt-BR": "Não especificado",
  "en-EU": "Not specified",
};

// Normalize and translate board types to the user's language
export function translateBoardType(boardDescription: string | undefined, language: string = "es"): string {
  const locale = normalizeLocaleKey(language);
  if (!boardDescription) return defaultTranslations[locale];

  const normalized = boardDescription.toLowerCase().trim();
  const translations = boardTypeTranslations[locale];

  // Exact match
  if (translations[normalized]) return translations[normalized];

  // Partial match
  for (const [key, value] of Object.entries(translations)) {
    if (normalized.includes(key)) return value;
  }

  // Fallback: original capitalized
  return boardDescription.charAt(0).toUpperCase() + boardDescription.slice(1);
}
